import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-fde419dc"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "flex-1 w-full"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, null, -1))
const _hoisted_3 = { class: "text-left pl-2" }
const _hoisted_4 = { class: "text-left pl-2" }
const _hoisted_5 = { class: "text-left pl-2" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "numberCol" }, null, -1))
const _hoisted_7 = { class: "data-tr items-center" }
const _hoisted_8 = {
  style: {"min-width":"120px","max-width":"200px"},
  class: "text-left pl-2"
}
const _hoisted_9 = {
  class: "text-left pl-2 numberCol",
  style: {"min-width":"120px","max-width":"200px"}
}
const _hoisted_10 = {
  class: "text-left pl-2 numberCol",
  style: {"min-width":"120px","max-width":"200px"}
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "numberCol" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (!_ctx.isTableOfContent && _ctx.freieMaengel.length > 0)
    ? (_openBlock(), _createElementBlock("table", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("tr", null, [
          _createElementVNode("th", _hoisted_3, _toDisplayString(_ctx.t("hzba.pdf.zuaetzlicheMaengel", 1, { locale: _ctx.lang })), 1),
          _createElementVNode("th", _hoisted_4, _toDisplayString(_ctx.t("hzba.mangel.kategorie", 1, { locale: _ctx.lang })), 1),
          _createElementVNode("th", _hoisted_5, _toDisplayString(_ctx.t("hzba.pdf.mangelBezeichnung", 1, { locale: _ctx.lang })), 1),
          _hoisted_6
        ]),
        _createElementVNode("tr", _hoisted_7, [
          _createElementVNode("td", _hoisted_8, [
            _createElementVNode("p", null, _toDisplayString(_ctx.name), 1)
          ]),
          _createElementVNode("td", _hoisted_9, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.customMaengel, (mangel, key) => {
              return (_openBlock(), _createElementBlock("span", { key: key }, _toDisplayString(mangel.custom.titel), 1))
            }), 128))
          ]),
          _createElementVNode("td", _hoisted_10, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.customMaengel, (mangel, key) => {
              return (_openBlock(), _createElementBlock("p", { key: key }, _toDisplayString(mangel.custom.kategorie), 1))
            }), 128))
          ]),
          _hoisted_11
        ])
      ]))
    : _createCommentVNode("", true)
}